import { isEscape, returnFocus, trapFocus, closeModals, removeMiniCartFocus, removeSearchFocus, breakpoints } from "./app/utils.js";

var returnFocusTo = window.returnFocusTo || null;

/*
ADA
*/
document.body.addEventListener('keyup', e => {
    if (isEscape(e)) {
        $(".dropdown").removeClass("is-open");
        $(".dropdown").find(".options a").attr("tabindex", "-1");
        $(".menu-item-has-children").removeClass("active");
        $(".sub-menu a").attr("tabindex", "-1");
        $('body').removeClass("minicart-shown search-shown");
        closeModals();
        removeMiniCartFocus();
        removeSearchFocus();
        returnFocus();
    }
});
const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
if (!!isReduced) {
    const heroVideo = document.querySelector('.wp-block-pulp-hero video');
    if (heroVideo) {
        heroVideo.pause();
    }
}

/*
Mobile UI
*/
document.getElementById('navigation-open').addEventListener('click', e => {
    e.preventDefault();
    document.body.classList.add('navigation-shown');
});

document.getElementById('navigation-close').addEventListener('click', e => {
    e.preventDefault();
    document.body.classList.remove('navigation-shown');
});

/*
Scroll events
*/
// window.addEventListener('scroll', throttle(100, function () {
//     if (window.scrollY > 50) {
//         document.body.classList.add('is-scrolled');
//         return;
//     }
//     document.body.classList.remove('is-scrolled');
// }));

/*
Navigation
*/
$("#navigation-open").on("click", function (e) {
    e.preventDefault();
    $('bodu').addClass("navigation-shown");
});
$("#navigation-close").on("click", function (e) {
    e.preventDefault();
    $('bodu').removeClass("navigation-shown");
    $("#site-navigation .active").removeClass("active");
    // $("#navigation-back").removeClass("shown");
});

$(".sub-menu a").attr("tabindex", -1);
$(".primary-nav__items > .menu-item-has-children > a").on("click", function (e) {
    e.preventDefault();
    let $parent = $(this).closest("li");
    window.menuItemToClose = $parent;
    $(".sub-menu a").attr("tabindex", "-1");
    if ($parent.hasClass("active")) {
        $parent.removeClass("active");
    } else {
        $(".menu-item-has-children").removeClass("active");
        $parent.addClass("active");
        window.returnFocusTo = $(this);
        $parent.find(".sub-menu a").removeAttr("tabindex");
        $parent.find('.sub-menu [href="#"]').attr("tabindex", "-1");
        trapFocus(document.getElementById($parent.attr("id")));
    }
});

/*
drop downs
*/
$(".dropdown .toggle").on("click", function (e) {
    e.preventDefault();
    let $parent = $(this).closest(".dropdown");
    let $options = $parent.find(".options");
    $parent.toggleClass("is-open");
    if ($parent.hasClass("is-open")) {
        window.returnFocusTo = $(this);
        $(this).attr("aria-expanded", true);
        $parent.find(".options a").removeAttr("tabindex");
        trapFocus(document.getElementById($options.attr("id")));
    } else {
        $(this).attr("aria-expanded", false);
        $parent.find(".options a").attr("tabindex", "-1");
    }
});

/*
FAQ toggles
*/
$(".faq__toggle").on("click", function (e) {
    e.preventDefault();
    const $items = $(this).closest('.wp-block-pulp-faq').find('.faq__item');
    if ($(this).hasClass("collapsed")) {
        $items.each(function () {
            $(this).attr('open', true);
        })
        $(this).removeClass("collapsed").text("Collapse All");
    } else {
        $items.each(function () {
            $(this).removeAttr('open');
        })
        $(this).addClass("collapsed").text("Expand All");
    }
});

require('./vendor/jquery.actual.min');
require('./vendor/youtube-iframe-assistant');
require('./vendor/chart.bundle.min');
require('./app/site-utilities.js');
require('./app/user');
require('./app/tabs');
require('./app/modals');
require('./app/product-selector.js');
require('./app/product.js');

require('./vendor/slick.min');
require('./app/sliders.js');
